import { Card, Col, Modal, Row, Select, Space, Tag } from "antd";
import {
  daysJsFormat,
  formatCurrency,
  languagesList,
  renderDiplomas,
  renderInterpreteCountry,
  renderLevel,
  renderUserGenderShort,
  renderUserName,
  roles,
  statusOption,
  statusPrestationsValues,
  typeIntervention,
} from "../../../utils/constants";
import {
  changePositionInterprete,
  changeStatusInterprete,
  setSelectedInterprete,
  updatePrestation,
} from "../Slices/Prestation.slice";
import React, { useContext } from "react";
import { useDispatch } from "react-redux";
import { manuelAttributeInterprete } from "../../../shared/components/Modals/modals";
import dayjs from "../../../utils/dayjs";
import dateFormat from "dateformat";
import { UserContext } from "../../../engine/context/User.context";

export const prestationInterpretesColumns = prestation => {
  const dispatch = useDispatch();

  const { user } = useContext(UserContext);


  const columns = [
    {
      title: "",
      dataIndex: "position",
      rowScope: "row",
      key: "position",
      width: "30px",
      render: (position, record) => (
        <>
          <Tag className={"largeTag"} size={"large"} color={"red"}>
            {record.position}
          </Tag>
        </>
      ),
    },
    {
      title: "Interprète",
      width: "120px",
      dataIndex: "user",
      key: "user",
      render: (text, record) => (
        <strong>{renderUserName(record.interprete)}</strong>
      ),
    },
    {
      title: "Genre",
      dataIndex: "genre",
      key: "genre",
      width: "40px",
      render: (g, record) => renderUserGenderShort(record.interprete),
    },

    {
      title: "Niveau",
      dataIndex: "levels",
      key: "levels",
      width: "100px",
      render: (text, record) => <span>{renderLevel(record?.interprete)} </span>,
    },
    {
      title: "Langue(s) interprétées(s)",
      dataIndex: "interpreteData",
      key: "interpreteData",
      width: "150px",
      render: (interpreteData, record) =>
        record.interprete.interpreteData.languages.map(lang => (
          <Tag size={"middle"} className={"greyTag"}>
            {languagesList.find(e => e.value === lang)?.label}
          </Tag>
        )),
    },
    {
      title: "Frais de déplacement (H.T)",
      dataIndex: "cost",
      key: "cost",
      width: "100px",
      render: (cost, record) => {
        return (
          <span>
            {typeIntervention.in_person === prestation.intervention.type
              ? formatCurrency(cost)
              : 0}
          </span>
        );
      },
    },
    {
      title: "Action & Ordre",
      dataIndex: "action",
      key: "action",
      width: "150px",
      render: (text, record) => {
        return (
          <Space>
            <Select
              disabled={
                prestation.status !== statusPrestationsValues.draft &&
                prestation.status !== statusPrestationsValues.waiting
              }
              key={record._id + record.status}
              value={record.status}
              style={{ width: 160 }}
              onChange={newValue => {
                if (newValue === "selected") {
                  manuelAttributeInterprete({
                    onOk: async () => {
                      await dispatch(
                        setSelectedInterprete(record.interprete._id),
                      );
                      await dispatch(
                        changeStatusInterprete({
                          _id: record.interprete._id,
                          status: newValue,
                        }),
                      );
                    },
                    content: {
                      record,
                    },
                  });
                } else {
                  dispatch(
                    changeStatusInterprete({
                      _id: record.interprete._id,
                      status: newValue,
                    }),
                  );
                }
              }}
              popupClassName={"colorfull"}
              className={"colorfull"}
            >
              {statusOption
                .filter(e => {
                  if (user.role === roles.institution) {
                    return (
                      e.value !== "selected" &&
                      e.value !== "not_available" &&
                      e.value !== "relance"
                    );
                  } else {
                    return true;
                  }
                })
                .map(option => (
                  <Select.Option
                    key={option?.value}
                    value={option?.value}
                    disabled={option?.disabled || false}
                  >
                    {option?.label()}
                  </Select.Option>
                ))}
            </Select>
            {/*<Select*/}
            {/*  key={record._id + record.position}*/}
            {/*  value={record.position}*/}
            {/*  style={{ width: 100 }}*/}
            {/*  onChange={newValue => {*/}
            {/*    dispatch(*/}
            {/*      changePositionInterprete({*/}
            {/*        _id: record.interprete._id,*/}
            {/*        position: newValue,*/}
            {/*      }),*/}
            {/*    );*/}
            {/*  }}*/}
            {/*>*/}
            {/*  <Select.Option key={1} value={1}>*/}
            {/*    Batch 1*/}
            {/*  </Select.Option>*/}
            {/*  <Select.Option key={2} value={2}>*/}
            {/*    Batch 2*/}
            {/*  </Select.Option>*/}
            {/*  <Select.Option key={3} value={3}>*/}
            {/*    Batch 3*/}
            {/*  </Select.Option>*/}
            {/*  <Select.Option key={4} value={4}>*/}
            {/*    Batch 4*/}
            {/*  </Select.Option>*/}
            {/*</Select>*/}
            {/*<label>*/}
            {/*  {notActive ? "Refusé" : "Invité"}*/}
            {/*  <Switch*/}
            {/*    checked={!notActive}*/}
            {/*    onClick={() => {*/}
            {/*      if (notActive) {*/}
            {/*        setNotInvited([...notInvited, record._id]);*/}
            {/*      } else {*/}
            {/*        setNotInvited([*/}
            {/*          ...notInvited.filter(e => e !== record._id),*/}
            {/*        ]);*/}
            {/*      }*/}
            {/*    }}*/}
            {/*  />*/}
            {/*</label>*/}
            {/*<Button*/}
            {/*  className={`${notActive ? "notActiveButton " : "activeButton"}`}*/}
            {/*  size={"middle"}*/}
            {/*  type={"primary"}*/}
            {/*  onClick={() => {*/}
            {/*    if (!notActive) {*/}
            {/*      setNotInvited([...notInvited, record._id]);*/}
            {/*    } else {*/}
            {/*      setNotInvited([...notInvited.filter(e => e !== record._id)]);*/}
            {/*    }*/}
            {/*  }}*/}
            {/*>*/}
            {/*  {notActive ? "Refusé" : "Invité"}*/}
            {/*  {notActive ? <BiPlus /> : <BiCheck />}*/}
            {/*</Button>*/}
          </Space>
        );
      },
    },
  ];
  return columns;
};

export const expandedRowRenderDetailInterpretes = props => {
  const { interprete, driving } = props;
  const { formations, country, lastDateFormation } = interprete.interpreteData;
  return (
    <div>
      <Row gutter={[15, 15]}>
        <Col span={24}>
          <Card>
            <Row gutter={[5, 5]}>
              <Col span={6}>
                <span className={"subTableOpenedInterprtesTitle"}>
                  Cours suivis
                </span>
                <span className={"subTableOpenedInterprtesContent"}>
                  {formations}
                </span>
              </Col>
              <Col span={6}>
                <span className={"subTableOpenedInterprtesTitle"}>
                  Dernière date de suivi
                </span>
                <span className={"subTableOpenedInterprtesContent"}>
                  {lastDateFormation !== null || lastDateFormation !== ""
                    ? dayjs(lastDateFormation).format(daysJsFormat.full)
                    : ""}
                </span>
              </Col>
              <Col span={6}>
                <span className={"subTableOpenedInterprtesTitle"}>
                  Années d'expérience
                </span>
                <span className={"subTableOpenedInterprtesContent"}>
                  10 ans
                </span>
              </Col>
              <Col span={6}>
                <span className={"subTableOpenedInterprtesTitle"}>
                  Qualifications
                </span>
                <span className={"subTableOpenedInterprtesContent"}>
                  {renderDiplomas(interprete)}
                </span>
              </Col>
              {/*<Col span={6}>*/}
              {/*  <span className={"subTableOpenedInterprtesTitle"}>*/}
              {/*    Pays d'origine*/}
              {/*  </span>*/}
              {/*  <span className={"subTableOpenedInterprtesContent"}>*/}
              {/*    {renderInterpreteCountry(interprete)}*/}
              {/*  </span>*/}
              {/*</Col>*/}
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
};
